import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { KycDetailsResponse, KycDetailsResponseSchema } from "@/schemas/wallet";

interface UserKYCParams {
  user?: string;
}

interface UseKYCOptions
  extends Omit<
    UseQueryOptions<
      KycDetailsResponse,
      Error,
      KycDetailsResponse,
      ["user", "kyc", string]
    >,
    "queryKey" | "queryFn"
  > {
  queryParams: UserKYCParams;
}

export function useUserKYC(options: UseKYCOptions) {
  const { queryParams } = options;

  return useSuspenseQuery({
    queryKey: ["user", "Kyc", queryParams.user],
    queryFn: async () => {
      const response = await axiosInstance.get(`/wallet/kyc/user/current`, {
        params: queryParams,
        baseURL: "/api/proxy",
      });
      return KycDetailsResponseSchema.parse(response.data);
    },
  });
}
